import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 384px;
    flex-shrink: 0;

    @media (max-width: 1200px) {
        width: 100%;
    }
`;